const STORAGE_KEY = "audio-form:r2-upload-events:v1";
const LIMIT = 200;

export type R2UploadKind =
  | "audio"
  | "transcript"
  | "llm"
  | "metrics"
  | "manifest"
  | "events"
  | "summary"
  | "answers"
  // 事前チェックの氏名発話 (spec 2026-07-29)。turn を持たないので turnId は付かない
  | "preflight-audio";

export type R2UploadEvent =
  | {
      kind: R2UploadKind;
      phase: "started";
      sessionId: string;
      turnId?: string;
      recordedAt: string;
    }
  | {
      kind: R2UploadKind;
      phase: "succeeded";
      sessionId: string;
      turnId?: string;
      recordedAt: string;
      latencyMs: number;
      bytesUploaded?: number;
    }
  | {
      kind: R2UploadKind;
      phase: "failed";
      sessionId: string;
      turnId?: string;
      recordedAt: string;
      attempts: number;
      error: string;
    };

function safeLoad(): R2UploadEvent[] {
  if (typeof localStorage === "undefined") return [];
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as R2UploadEvent[]) : [];
  } catch {
    return [];
  }
}

function safeSave(events: R2UploadEvent[]): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(events));
  } catch {
    /* QuotaExceeded は黙って無視 */
  }
}

export function logR2Upload(event: R2UploadEvent): void {
  const label = `[r2:${event.kind}:${event.phase}]`;
  if (event.phase === "failed") {
    console.warn(label, event);
  } else {
    console.log(label, event);
  }
  const all = safeLoad();
  all.push(event);
  const trimmed = all.length > LIMIT ? all.slice(all.length - LIMIT) : all;
  safeSave(trimmed);
}

export function getR2UploadEvents(): R2UploadEvent[] {
  return safeLoad();
}

export function clearR2UploadEvents(): void {
  if (typeof localStorage === "undefined") return;
  localStorage.removeItem(STORAGE_KEY);
}
